import React, { useState, useEffect } from 'react';
import '../../styles/ui/InstallPrompt.css';
import { isNative } from '../../utils/platform';

const DISMISS_KEY = 'adwary_pwa_dismissed';

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (isNative) return;

    try {
      if (localStorage.getItem(DISMISS_KEY)) return;
    } catch { /* ignore */ }

    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    if (isStandalone) return;

    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    if (isIos) {
      setIosHint(true);
      setVisible(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const dismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch { /* ignore */ }
  };

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    dismiss();
  };

  if (!visible) return null;

  return (
    <div className="install-prompt">
      <div className="install-prompt-content">
        <span className="install-prompt-icon" aria-hidden="true">📲</span>
        <div>
          <p className="install-prompt-title">ثبّت ادواري على هاتفك</p>
          <p className="install-prompt-text">
            {iosHint
              ? 'اضغط مشاركة ثم «إضافة إلى الشاشة الرئيسية»'
              : 'احجز بسرعة كتطبيق — بدون متجر'}
          </p>
        </div>
      </div>
      <div className="install-prompt-actions">
        {!iosHint && deferredPrompt && (
          <button type="button" className="install-prompt-btn primary" onClick={handleInstall}>
            تثبيت
          </button>
        )}
        <button type="button" className="install-prompt-btn ghost" onClick={dismiss}>
          لاحقاً
        </button>
      </div>
    </div>
  );
}

export default InstallPrompt;
